import buttonPrimary from './buttons/buttonPrimary';
import buttonSecondary from './buttons/buttonSecondary';
import buttonHeroPrimary from './buttons/buttonHeroPrimary';
import buttonHeroSecondary from './buttons/buttonHeroSecondary';
import buttonHeroPrimaryTop from './buttons/buttonHeroPrimaryTop';
import buttonHeroSecondaryTop from './buttons/buttonHeroSecondaryTop';

export default [buttonPrimary, buttonSecondary, buttonHeroPrimary, buttonHeroSecondary, buttonHeroPrimaryTop, buttonHeroSecondaryTop];
